<script lang="ts" setup>
import { computed } from 'vue'

import type { ConnectionTier } from '../model/types/classroom/enums'

import { useConnectionSignalGlyph } from '../model/connection-signal-glyph.hook'

defineOptions({
  name: 'ConnectionSignalGlyph',
})

const props = withDefaults(defineProps<{
  tier: ConnectionTier
  surface?: 'light' | 'dark'
}>(), {
  surface: 'light',
})

const refTier = computed<ConnectionTier>(() => props.tier)

const {
  bars,
  refLitCount,
  refIsLost,
  refLabel,
} = useConnectionSignalGlyph({ tier: refTier })
</script>

<template>
  <svg
    :class="['connection-glyph', `connection-glyph--${tier.toLowerCase()}`, `connection-glyph--${surface}`]"
    viewBox="0 0 18 14"
    role="img"
    :aria-label="refLabel"
  >
    <title>{{ refLabel }}</title>
    <rect
      v-for="(bar, index) in bars"
      :key="bar.x"
      :class="['connection-glyph__bar', index < refLitCount ? 'connection-glyph__bar--lit' : 'connection-glyph__bar--dim']"
      :x="bar.x"
      :y="bar.y"
      :height="bar.height"
      width="3.6"
      rx="1.2"
    />
    <path
      v-if="refIsLost"
      class="connection-glyph__slash"
      d="M1 13.4 17 1"
      stroke-width="1.7"
      stroke-linecap="round"
    />
  </svg>
</template>

<style scoped lang="scss" src="./ConnectionSignalGlyph.scss" />
